import RouteSectionsPrefixes from "@/entities/RouteSectionsPrefixes";
import Route from "@/entities/Route";
import {
  getDashboardChildRoutes,
  getDashboardRoutes,
} from "@/router/management/pages/dashboard";
import {
  getPostingPrivatePageTabsRoutes,
  getPostingsRoutes,
  getPostingPrivatePageRoutes,
} from "@/router/management/pages/postings";
import {
  getProjectsRoutes,
  getMainAllClientsTabsRoutes,
  getMainAllVisitsRoutes,
  getProjectPrivatePageRoutes,
  getMainTwoTabRoutes,
} from "@/router/management/pages/projects";
import {
  getRequestRoutes,
  getRequestPrivatePageTabsRoutes,
  getRequestPrivatePageRoutes,
} from "@/router/management/pages/requests";
import {
  getNewCompanyCalendarRoutes,
  getNewCompanyPrivateCalendarRoutes,
} from "@/router/management/pages/new-schedule";
import {
  getManagersRoutes,
  getManagerPrivatePageRoutes,
  getManagerPrivatePageTabsRoutes,
  getManagerPrivatePageRoutesWrapper,
  getManagerPrivatePageTabRoutesChildren,
} from "@/router/management/pages/managers";
import {
  getGroupsRoutes,
  getGroupPrivatePageRoutes,
  getGroupPrivatePageTabsRoutes,
} from "@/router/management/pages/groups";
import {
  getContractorPrivatePageRoutes,
  getContractorPublicPageRoutes,
  getManagerContractorsDatabaseRoutes,
  getContractorPrivatePageTabsRoutes,
  getMarketplaceContractorsRoutes,
  getMyFavoritesContractorsRoutes,
  getCompanyContractorsDatabaseRoutes,
  getCompanyContractorsDatabaseTabsRoutes,
  getCompanyContractorsRoutes,
  getCompanyContractorsRequestsRoutes,
  getCompanyContractorsArchived,
  getCompanyContractorsCustomRequestsRoutes,
  getTalentMappingRoutes,
  getCompanyContractorsCustomPendingRoutes,
} from "@/router/management/pages/contractors";
import { getDocumentsRoutes } from "@/router/management/pages/documents";
import {
  getInvoicePrivatePageTabsRoutes,
  getInvoicePrivateSubmit,
  getInvoicesRoutes,
  getInvoicePrivatePageRoutes,
} from "./pages/invoice";
import { getOnboardingRoutes } from "./pages/onboarding";
import {
  getTimesheetPrivatePageTabsRoutes,
  getTimesheetPrivateSubmit,
  getTimesheetRoutes,
} from "./pages/timesheet";
import {
  getSchedulerPrivatePageTabsRoutes,
  getSchedulerPrivateSubmit,
  getSchedulerRoutes,
} from "./pages/calendar";

export const managementRoutes: Route[] = [
  ...getDashboardRoutes({
    children: [...getDashboardChildRoutes({})],
  }),

  ...getTimesheetRoutes({
    children: [
      ...getTimesheetPrivatePageTabsRoutes({
        children: [...getTimesheetPrivateSubmit({})],
      }),
    ],
  }),
  ...getNewCompanyCalendarRoutes({
    children: [...getNewCompanyPrivateCalendarRoutes({})],
  }),
  ...getCompanyContractorsDatabaseRoutes({
    children: [
      // ...getTimesheetRoutes({
      //   children: [
      //     ...getTimesheetPrivatePageTabsRoutes({
      //       children: [...getTimesheetPrivateSubmit({})],
      //     }),
      //   ],
      // }),
      ...getCompanyContractorsDatabaseTabsRoutes({
        children: [
          ...getCompanyContractorsRoutes({}),
          ...getMyFavoritesContractorsRoutes({}),
          ...getCompanyContractorsRequestsRoutes({}),
          ...getTalentMappingRoutes({}),
          ...getCompanyContractorsArchived({}),
          ...getCompanyContractorsCustomRequestsRoutes({}),
          ...getCompanyContractorsCustomPendingRoutes({}),
        ],
      }),

      ...getContractorPrivatePageRoutes({
        children: [...getContractorPrivatePageTabsRoutes({})],
      }),
      ...getContractorPrivatePageRoutes({
        prefix: RouteSectionsPrefixes.COMPANY_DATABASE__CONTRACTORS,
        children: [
          ...getContractorPrivatePageTabsRoutes({
            prefix: RouteSectionsPrefixes.COMPANY_DATABASE__CONTRACTORS,
          }),
        ],
      }),
      ...getContractorPublicPageRoutes({
        prefix: RouteSectionsPrefixes.COMPANY_DATABASE__CONTRACTORS,
      }),
      ...getContractorPrivatePageRoutes({
        prefix: RouteSectionsPrefixes.COMPANY_DATABASE__REQUESTS,
        children: [
          ...getContractorPrivatePageTabsRoutes({
            prefix: RouteSectionsPrefixes.COMPANY_DATABASE__REQUESTS,
          }),
        ],
      }),
      ...getContractorPublicPageRoutes({
        prefix: RouteSectionsPrefixes.COMPANY_DATABASE__REQUESTS,
      }),
    ],
  }),
  ...getProjectsRoutes({
    children: [
      ...getMainTwoTabRoutes({
        children: [
          ...getMainAllVisitsRoutes({}),
          ...getMainAllClientsTabsRoutes({}),
        ],
      }),
      ...getProjectPrivatePageRoutes({}),
    ],
  }),
  ...getRequestRoutes({
    children: [
      ...getRequestPrivatePageRoutes({
        children: [...getRequestPrivatePageTabsRoutes({})],
      }),
    ],
  }),
  ...getPostingsRoutes({
    children: [
      ...getPostingPrivatePageRoutes({
        children: [...getPostingPrivatePageTabsRoutes({})],
      }),
    ],
  }),

  ...getManagersRoutes({
    children: [
      ...getManagerPrivatePageRoutesWrapper({
        children: [...getManagerPrivatePageRoutes({})],
      }),
    ],
  }),

  ...getGroupsRoutes({
    children: [
      ...getGroupPrivatePageRoutes({
        children: [...getGroupPrivatePageTabsRoutes({})],
      }),
    ],
  }),

  ...getSchedulerRoutes({
    children: [
      ...getSchedulerPrivatePageTabsRoutes({
        children: [...getSchedulerPrivateSubmit({})],
      }),
    ],
  }),

  ...getManagerContractorsDatabaseRoutes({
    children: [
      ...getContractorPrivatePageRoutes({
        prefix: RouteSectionsPrefixes.MY_DATABASE,
        children: [
          ...getContractorPrivatePageTabsRoutes({
            prefix: RouteSectionsPrefixes.MY_DATABASE,
          }),
        ],
      }),
    ],
  }),

  ...getMarketplaceContractorsRoutes({
    children: [
      ...getContractorPublicPageRoutes({
        prefix: RouteSectionsPrefixes.COMPANY_DATABASE__CONTRACTORS,
      }),
      ...getContractorPublicPageRoutes({}),
    ],
  }),

  // ...getMyFavoritesContractorsRoutes({
  // 	children: [
  // 		...getContractorPrivatePageRoutes({
  // 			prefix: RouteSectionsPrefixes.MY_FAVORITES,
  // 			children: [
  // 				...getContractorPrivatePageTabsRoutes({
  // 					prefix: RouteSectionsPrefixes.MY_FAVORITES,
  // 				}),
  // 			],
  // 		}),
  // 	],
  // }),

  ...getDocumentsRoutes({}),

  ...getInvoicesRoutes({
    children: [
      ...getInvoicePrivatePageTabsRoutes({
        children: [...getInvoicePrivateSubmit({})],
      }),
    ],
  }),
  ...getOnboardingRoutes,
];
